// // /*********************
//  * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
//  * __________________
//  *
//  *  Mobillor Technologies Pvt. Ltd.
//  *  All Rights Reserved.
//  *
//  * NOTICE:  All information contained herein is, and remains
//  * the property of Mobillor Technologies Pvt. Ltd.
//  * The intellectual and technical concepts contained
//  * herein are proprietary to Mobillor Technologies Pvt. Ltd.
//  * may be covered by Rebublic Of India and Foreign Patents,
//  * patents in process, and are protected by trade secret or copyright law.
//  * Dissemination of this information or reproduction of this material
//  * is strictly forbidden unless prior written permission is obtained
//  * from Mobillor Technologies Pvt. Ltd.
//  */

import { useEffect, useState } from "react";

import { connect } from "react-redux";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";

// React-Select component and styling
import Select from "react-select";
import "../../../index.css";

//  formik and yup
import { useFormik } from "formik";
import * as Yup from "yup";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import Icon from "@mui/material/Icon";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import TextError from "utils/TextError";

import { Tree } from "primereact/tree";

// Functions from store
import {
  createRoles,
  deleteRoles,
  editRoles,
  getAllClients,
  getAllRoles,
  getComponents,
  getDepartments,
  getModuleForEdit,
  getModuleForView,
  getModules,
  getModulesForEditRole,
  getSubModule,
  getSubModuleForCreateRole,
  getSubModuleForView,
  getSubModulesByRoleId,
} from "../../../store";

import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import EditButton from "components/standardized-components/EditButton";
import ViewButton from "components/standardized-components/ViewButton";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const UserRoles = ({
  getAllRolesReducer,
  getAllRoles,
  deleteRoles,
  createRoles,
  editRoles,
  getModules,
  getModulesReducer,
  getSubModule,
  getSubModulesReducer,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getSubModuleForView,
  getSubModulesForViewReducer,
  getAllClients,
  getModuleForView,
  getModulesForViewReducer,
  getAdminModuleRolesReducer,
  getModuleForEdit,
  getModulesForEditReducer,
  getSubModuleForCreateRole,
  getModulesForEditRolesReducer,
  getAllClientsReducer,
  getSubModulesForCreateRoleReducer,
  componentsReducer,
  getDepartments,
  departments,
  getModulesForEditRole,
  getComponents,
}) => {
  const deleteStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: 340, sm: 340, md: 340, lg: 330, xl: 330 },
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  const styleForCreateRole = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: 340, sm: 340, md: 450, lg: 840, xl: 840 },
    height: "fit-content",
    maxHeight: { xs: 340, sm: 340, md: 440, lg: 600, xl: 600 },
    boxShadow: 24,
    p: 1,
    pt: 2,
  };

  let data = cookies.get("loginDetailsForWMS");

  let jwtToken = data?.jwt;
  let roleId = data.data.roleId;
  let roleName = data?.data?.roleName;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesAccessData, setModulesAccessData] = useState([]);

  useEffect(() => {
    setModulesAccessData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  const [submitLoader, setSubmitLoader] = useState(false);
  const [productsData, setProductsData] = useState({});
  const [roleDataForEdit, setRoleDataForEdit] = useState({});
  const [roleIdForView, setRoleIdForView] = useState("");
  const [clientIdForView, setClientIdForView] = useState("");
  const [moduleIdForView, setModuleIdForView] = useState("");
  let [roleIdForUpdate, setRoleIdForUpdate] = useState("");
  let [moduleIdForUpdate, setModuleIdForUpdate] = useState("");

  useEffect(() => {
    getAllRoles(jwtToken);
  }, [getAllRoles]);
  useEffect(() => {
    getComponents(jwtToken);
  }, []);
  useEffect(() => {
    getAllClients(jwtToken);
  }, []);

  let [subModuleForCreateRole, setSubModuleForCreateRole] = useState({});

  // useEffect(async () => {
  //   let tempSubModulesData = {};
  //   let subModulesData = await getSubModuleForCreateRole(jwtToken);
  //   tempSubModulesData["subModulesForCreateRole"] = subModulesData.data;
  //   setSubModuleForCreateRole(tempSubModulesData);
  // }, []);

  const [assemblyTypesSelectedForEdit, setAssemblyTypesSelectedForEdit] =
    useState("");
  const [componentTypesSelectedForEdit, setComponentTypesSelectedForEdit] =
    useState("");
  const [componentUpdateOptions, setComponentUpdateOptions] = useState("");

  const handleChangeComponentTypesForEdit = (selectedOption) => {
    setComponentTypesSelectedForEdit(selectedOption);
  };
  const handleChangeAssemblyTypesForEdit = (selectedOption) => {
    setAssemblyTypesSelectedForEdit(selectedOption);
  };
  useEffect(() => {
    getSubModule(jwtToken, roleIdForUpdate, moduleIdForUpdate);
  }, [getSubModule, roleIdForUpdate, moduleIdForUpdate]);

  useEffect(() => {
    getModuleForView(roleIdForView, jwtToken);
  }, [roleIdForView]);

  useEffect(() => {
    getModuleForEdit(roleIdForView, jwtToken);
  }, [roleIdForView]);

  // useEffect(() => {
  //   getModuleForEdit(jwtToken, roleIdForView);
  // }, [getModuleForView, roleIdForView]);

  let payload = { roleId: roleIdForView, moduleId: moduleIdForView };

  useEffect(() => {
    getSubModuleForView(jwtToken, payload);
  }, [getSubModuleForView, roleIdForView, moduleIdForView]);

  let subModuleDataForView = getSubModulesForViewReducer?.subModuleData?.data
    ? getSubModulesForViewReducer?.subModuleData?.data
    : [];

  let moduleDataForView = getModulesForViewReducer?.moduleData?.data
    ? getModulesForViewReducer?.moduleData?.data
    : [];

  let moduleDataForEdit = getModulesForEditReducer?.moduleData?.data
    ? getModulesForEditReducer?.moduleData?.data
    : [];
  let editModulesByComponentId = getModulesForEditRolesReducer?.rolesData?.data
    ? getModulesForEditRolesReducer?.rolesData?.data
    : [];

  let viewLoading = getModulesForViewReducer?.loading;
  let editLoading = getModulesForEditReducer?.loading;

  // const [modulesDataForView, setModulesDataForView] = useState([]);
  // useEffect(async () => {
  //   let tempModulesData = {};
  //   let modulesData = await getModuleForView(jwtToken, roleIdForView);
  //   tempModulesData["ModulesForView"] = modulesData.data;
  //   setModulesDataForView(tempModulesData);
  // }, [roleIdForView]);

  const [departmentSelected, setDepartmentSelected] = useState({});
  const handleDepartmentSelected = (selectedOption) => {
    setDepartmentSelected(selectedOption);
  };

  const [departmentsOptions, setDepartmentsOptions] = useState([]);
  useEffect(() => {
    let tempDepartments = departments.departments.data
      ? departments.departments.data
      : [];
    let departmentOptionsTemp = [];
    tempDepartments.map((department) => {
      departmentOptionsTemp.push({
        label: department.departmentName,
        value: department.departmentId,
      });
    });
    setDepartmentsOptions(departmentOptionsTemp);
  }, [departments]);

  const [componentSelected, setComponentSelected] = useState({});

  const [clientSelected, setClientSelected] = useState({});
  const handleClientSelected = (selectedOption) => {
    setClientSelected(selectedOption);
  };

  const [componentOptions, setComponentOptions] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);

  useEffect(() => {
    let tempDocumentTypeOptions = [];
    let data = getAllClientsReducer.clients.data
      ? getAllClientsReducer.clients.data
      : [];
    data.map((document) => {
      tempDocumentTypeOptions.push({
        label: document.clientName,
        value: document.clientId,
      });
    });
    setClientOptions(tempDocumentTypeOptions);
  }, [getAllClientsReducer]);

  useEffect(() => {
    let tempDocumentTypeOptions = [];
    let data = componentsReducer.components.data
      ? componentsReducer.components.data
      : [];
    data.map((document) => {
      tempDocumentTypeOptions.push({
        label: document.componentName,
        value: document.componentId,
      });
    });
    setComponentOptions(tempDocumentTypeOptions);
  }, [componentsReducer]);

  let clientRoles = modulesAccessData.find(
    (moduleId) => moduleId.moduleId == "6d01ae38-4c16-4571-acb4-8b5eb9e76dcf",
  );

  let createAccess = clientRoles
    ? clientRoles.actionId.includes("40429ac7-feea-4050-b83d-6cb377368bee")
    : null;

  let viewAccess = clientRoles
    ? clientRoles.actionId.includes("024ddc19-7131-47bc-8a4e-73ee718d80ee")
    : null;

  let updateAccess = clientRoles
    ? clientRoles.actionId.includes("473fe517-5f99-4094-8f56-8f1685f9699c")
    : null;

  let deleteAccess = clientRoles
    ? clientRoles.actionId.includes("7f07016d-03a3-4e8f-8055-47f244d2e459")
    : null;

  const [loading, setLoading] = useState(true);

  // const [nodes, setNodes] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState(moduleDataForEdit);

  useEffect(() => {
    setSelectedKeys(moduleDataForEdit);
  }, [getModulesForEditReducer]);

  let payloadArr = [];

  Object.keys(selectedKeys).forEach(
    (key) => (selectedKeys[key].subModuleId = key),
  );

  Object.values(selectedKeys).forEach((el) => payloadArr.push(el));

  const [opendeleteRolesModal, setOpendeleteRolesModal] = useState(false);
  const [singleClientDataForDelete, setClientDataForDelete] = useState({});

  const handleOpendeleteRolesModal = (department = {}) => {
    setClientDataForDelete(department);
    setOpendeleteRolesModal(true);
  };

  const handleClosedeleteRolesModal = () => {
    setOpendeleteRolesModal(false);
  };
  const [isErrordeleteRoles, setIsErrordeleteRoles] = useState(false);

  useEffect(() => {
    if (isErrordeleteRoles) {
      setTimeout(() => {
        setIsErrordeleteRoles(false);
      }, 3000);
    }
  }, [isErrordeleteRoles]);

  const [deleteErrorMsg, setDeleteErrorMsg] = useState("");

  const deleteRolesData = async () => {
    let roleId = singleClientDataForDelete.roleId;
    let response = await deleteRoles(jwtToken, roleId);
    if (response.status) {
      handleClosedeleteRolesModal();
      getAllRoles(jwtToken);
    }
    if (!response.status) {
      setDeleteErrorMsg(response.data.data.message);
      setIsErrordeleteRoles(true);
    }
  };

  const [openEditRoleModal, setOpenEditRoleModal] = useState(false);

  const handleOpenEditRoleModal = (data) => {
    const filteredComponentIds = data.componentIds.filter(
      (component) => component.isChecked,
    );
    setComponentTypesSelectedForEdit(filteredComponentIds);
    setComponentUpdateOptions(data.componentIds);

    setOpenEditRoleModal(true);
    setRoleDataForEdit(data);
    setDepartmentSelected({
      label: data.departmentName,
      value: data.departmentId,
    });
    setAssemblyTypesSelectedForEdit({
      label: data.clientName,
      value: data.clientId,
    });
    setRoleIdForUpdate(data.roleId);
    setRoleIdForView(data.roleId);
    setClientIdForView(data.clientId);
    getModuleForEdit(roleIdForView, jwtToken);
  };

  const handleCloseEditRoleModal = () => {
    setOpenEditRoleModal(false);
    getAllRoles(jwtToken);
    setSelectedKeys("");

    formik.setValues(initialValues);
    formik.setTouched({});
    formik.setErrors({});
  };

  const [isSuccessEditRole, setIsSuccessEditRole] = useState(false);
  const [isErrorEditRole, setIsErrorEditRole] = useState(false);

  useEffect(() => {
    if (isSuccessEditRole) {
      setTimeout(() => {
        setIsSuccessEditRole(false);
      }, 3000);
    }
  }, [isSuccessEditRole]);

  useEffect(() => {
    if (isErrorEditRole) {
      setTimeout(() => {
        setIsErrorEditRole(false);
      }, 3000);
    }
  }, [isErrorEditRole]);

  const initialValues = {
    roleName: roleDataForEdit ? roleDataForEdit.roleName : "",
    description: roleDataForEdit ? roleDataForEdit.description : "",
    // departmentId: roleDataForEdit ? roleDataForEdit.departmentId : "",
  };

  const validationSchema = Yup.object({
    roleName: Yup.string().required("Enter the role name"),
    description: Yup.string().required("Enter the description"),
  });

  useEffect(() => {
    getModulesForEditRole(componentTypesSelectedForEdit, jwtToken);
  }, [componentTypesSelectedForEdit]);

  const [editErrorMsg, setEditErrorMsg] = useState("");

  const onSubmit = async (values, { resetForm }) => {
    // setSubmitLoader(true);
    // values.roleId = roleDataForEdit?.roleId;
    const actionIds = payloadArr.map((actionId) => actionId); // Adjust this according to your payload structure

    let payload = {
      roleName: values.roleName,
      description: values.description,
      departmentId: "",
      clientId: assemblyTypesSelectedForEdit.value,
      componentIds: componentTypesSelectedForEdit.map((component) => ({
        componentId: component.value,
      })),
      subModuleIds: actionIds,
      roleId: roleIdForView,
      clientId: clientIdForView,
    };
    let response = await editRoles(payload, jwtToken);
    if (response.status === true) {
      setSubmitLoader(false);
      setIsSuccessEditRole(true);
      getAllRoles(jwtToken);
      // setTimeout(() => {
      //   handleCloseEditRoleModal();
      // }, 2250);
      setRoleIdForUpdate("");
      setModuleIdForUpdate("");
      getSubModuleForView(jwtToken, payload);
      getModuleForView(roleIdForView);
      getSubModule(jwtToken, roleIdForUpdate, moduleIdForUpdate);
      getSubModulesByRoleId(roleId, jwtToken);
      getModules(jwtToken);
      resetForm();
    }
    if (response.status === false) {
      setEditErrorMsg(response.data.data.message);
      setSubmitLoader(false);
      setIsErrorEditRole(true);
    }
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: onSubmit,
    validationSchema: validationSchema,
    enableReinitialize: true,
  });

  //    create role
  const [openCreateRoleModal, setOpenCreateRoleModal] = useState(false);

  const handleOpenCreateRoleModal = (data) => {
    setOpenCreateRoleModal(true);
    setRoleIdForUpdate(data?.roleId);
    setOpenCreateRoleModal(true);
    setDepartmentSelected("");
    setSelectedKeys("");
  };
  const [selectedValues, setSelectedValues] = useState([]);

  const handleCloseCreateRoleModal = () => {
    setComponentSelected("");
    setSelectedValues("");
    setClientSelected("");
    setOpenCreateRoleModal(false);
    getAllRoles(jwtToken);
    formikForCreateRole.setValues(initialValuesForCreateRole);
    formikForCreateRole.setTouched({});
    formikForCreateRole.setErrors({});

    // Reset the componentId field to an empty array
    formikForCreateRole.setFieldValue("componentId", []);
  };

  const [isSuccessCreateRole, setIsSuccessCreateRole] = useState(false);
  const [isErrorCreateRole, setIsErrorCreateRole] = useState(false);
  useEffect(() => {
    if (isSuccessCreateRole) {
      setTimeout(() => {
        setIsSuccessCreateRole(false);
      }, 3000);
    }
  }, [isSuccessCreateRole]);

  useEffect(() => {
    if (isErrorCreateRole) {
      setTimeout(() => {
        setIsErrorCreateRole(false);
      }, 3000);
    }
  }, [isErrorCreateRole]);

  const initialValuesForCreateRole = {
    roleName: "",
    description: "",
    departmentId: "",
    componentId: [],
    clientId: "",
  };

  const validationSchemaForCreateRole = Yup.object({
    roleName: Yup.string().required("Enter the role name"),
    description: Yup.string().required("Enter the description"),
  });

  const [createErrorMsg, setCreateErrorMsg] = useState("");

  const handleComponentSelected = (selectedOption) => {
    const values = {
      componentIds: selectedOption
        ? selectedOption.map((option) => ({
            component: option.value,
          }))
        : [],
    };
    setSelectedValues(values);
  };

  useEffect(() => {
    getSubModuleForCreateRole(selectedValues, jwtToken);
  }, [selectedValues]);

  let subModuleDataForCreate = getSubModulesForCreateRoleReducer
    ?.subModulesDataForCreateRole?.data
    ? getSubModulesForCreateRoleReducer?.subModulesDataForCreateRole?.data
    : [];

  const onSubmitForCreateRole = async (values, { resetForm }) => {
    setSubmitLoader(true);

    const componentIds = values.componentId
      ? values.componentId.map((option) => ({ componentId: option.value }))
      : [];

    const actionIds = payloadArr.map((subModuleId) => subModuleId);

    const payload = {
      roleName: values.roleName,
      departmentId: "",
      description: values.description,
      clientId: clientSelected.value,
      componentIds: componentIds,
      subModuleIds: actionIds,
    };
    let response = await createRoles(payload, jwtToken);

    if (response.status === true) {
      setComponentSelected("");
      setClientSelected("");
      setSubmitLoader(false);
      setIsSuccessCreateRole(true);
      getAllRoles(jwtToken);
      resetForm();
      setSubModulesActionsForCreateRole([]);
      getSubModuleForView(jwtToken, payload);
      getModuleForView(roleIdForView);
      getSubModule(jwtToken, roleIdForUpdate, moduleIdForUpdate);
      getSubModulesByRoleId(roleId, jwtToken);
      getModules(jwtToken);
      setTimeout(() => {
        handleCloseCreateRoleModal();
      }, 2500);
    }
    if (!response.status) {
      setCreateErrorMsg(response.data.data.message);
      setSubmitLoader(false);
      setIsErrorCreateRole(true);
    }
  };

  const formikForCreateRole = useFormik({
    initialValues: initialValuesForCreateRole,
    onSubmit: onSubmitForCreateRole,
    validationSchema: validationSchemaForCreateRole,
  });

  const selectCrudOperation = (a) => {};
  const [openCrudOperationModal, setOpenCrudOperationModal] = useState(false);

  const handleOpenCrudOperationModal = (data) => {
    setOpenCrudOperationModal(true);
  };

  const handleCloseCrudOperationModal = () => {
    setOpenCrudOperationModal(false);
  };

  let [productsList, setProductsList] = useState([]);
  let [modules, setModules] = useState({});
  let [modulesForView, setModulesForView] = useState({});

  let [subModule, setSubModule] = useState({});

  // submodules ka data
  let subModulesData = getSubModulesReducer?.subModulesData?.data
    ? getSubModulesReducer?.subModulesData?.data
    : [];

  const [testingData, setTestingData] = useState([]);
  const [testSubModule, setTestSubModule] = useState(subModulesData || []);

  const [modulesActions, setModulesActions] = useState([]);
  const [subModulesActions, setSubModulesActions] = useState([]);
  const [subModulesActionsForCreateRole, setSubModulesActionsForCreateRole] =
    useState([]);

  const [parentModuleId, setParentModuleId] = useState("");

  const [itemTable, setItemTable] = useState({
    columns: [
      { Header: "role name", accessor: "roleName" },
      { Header: "description", accessor: "description" },
      {
        Header: "action",
        accessor: "action",
        align: "center",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns: itemColumns, rows: itemRows } = itemTable;

  useEffect(() => {
    let tempRoles = [];
    let data = getAllRolesReducer?.rolesData?.data
      ? getAllRolesReducer?.rolesData?.data
      : [];
    setLoading(getAllRolesReducer.loading);

    if (getAllRolesReducer?.rolesData?.data?.length) {
      data?.map((data) => {
        const singledata = {
          roleName: data.roleName,
          description: data.description,

          action: (
            <>
              <span style={{ display: "flex" }}>
                <ViewButton
                  tooltip="View"
                  style={{ marginLeft: "10px" }}
                  variant="gradient"
                  color="info"
                  iconOnly
                  type="button"
                  onClick={() => handleopenViewModal(data)}
                >
                  <Icon> visibility_icon </Icon>
                </ViewButton>

                {updateAccess && (
                  <EditButton
                    style={{ marginLeft: "5px" }}
                    tooltip="Edit Role"
                    variant="gradient"
                    color="success"
                    iconOnly
                    type="button"
                    onClick={() => {
                      handleOpenEditRoleModal(data);
                      getDepartments(jwtToken);
                    }}
                  >
                    <Icon> edit </Icon>
                  </EditButton>
                )}

                {deleteAccess && (
                  <DeleteButton
                    tooltip="Delete Role"
                    style={{ marginLeft: "5px" }}
                    variant="gradient"
                    color="error"
                    iconOnly
                    type="button"
                    onClick={() => handleOpendeleteRolesModal(data)}
                  >
                    <DeleteIcon />
                  </DeleteButton>
                )}
              </span>
            </>
          ),
        };
        tempRoles.push(singledata);
      });
    }
    viewAccess && setItemTable({ ...itemTable, rows: tempRoles });
  }, [getAllRolesReducer]);

  const [openViewModal, setopenViewModal] = useState(false);

  const handleopenViewModal = (data = {}) => {
    setRoleIdForView(data.roleId);
    setClientIdForView(data.clientId);
    setopenViewModal(true);
    getModuleForView(roleIdForView, jwtToken);
  };

  const handleCloseViewModal = () => {
    setopenViewModal(false);
    getAllRoles(jwtToken);
    getSubModuleForView(jwtToken, payload);
    getModuleForView(roleIdForView);
    getSubModule(jwtToken, roleIdForUpdate, moduleIdForUpdate);
    getSubModulesByRoleId(roleId, jwtToken);
    getModules(jwtToken);
  };

  return (
    <>
      <>
        <MDBox mt={-8}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              {createAccess && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  p={3}
                >
                  <MDBox>
                    <CreateButton
                      tooltip="Create Role"
                      color="info"
                      variant="contained"
                      type="button"
                      onClick={() => {
                        handleOpenCreateRoleModal();
                        getDepartments(jwtToken);
                      }}
                    >
                      <Icon>add</Icon>
                    </CreateButton>
                  </MDBox>
                </MDBox>
              )}
              <MDBox mt={createAccess ? -3 : 0}>
                {!loading ? (
                  <DataTable
                    table={{ columns: itemColumns, rows: itemRows }}
                    isSorted={true}
                    tableSearch={true}
                    entriesPerPage={{
                      defaultValue: 5,
                      entries: [5, 10, 15, 20, 25, 30],
                    }}
                  />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "100px",
                      marginBottom: "100px",
                    }}
                  >
                    <CircularProgress color="info" />
                  </div>
                )}
              </MDBox>
            </Grid>
            <Grid>
              <Modal
                open={opendeleteRolesModal}
                onClose={handleClosedeleteRolesModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={deleteStyle}>
                  <MDTypography>Are you sure you want to delete?</MDTypography>
                  <MDBox mt={2}>
                    <div style={{ display: "flex" }}>
                      <div>
                        <MDButton
                          style={{ width: "100%", marginRight: "0.5rem" }}
                          color="info"
                          variant="outlined"
                          onClick={handleClosedeleteRolesModal}
                        >
                          Cancel
                        </MDButton>
                      </div>
                      <div>
                        <MDButton
                          style={{ width: "100%", marginLeft: "0.5rem" }}
                          color="error"
                          onClick={deleteRolesData}
                        >
                          Delete
                        </MDButton>
                      </div>
                    </div>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isErrordeleteRoles}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrordeleteRoles(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {/* Please check the details. Server error! */}
                        {deleteErrorMsg}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>
            </Grid>

            <Modal
              open={openCreateRoleModal}
              onClose={handleCloseCreateRoleModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForCreateRole}>
                <MDBox ml={1} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Create Role
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseCreateRoleModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>

                <hr />

                <MDBox pt={1} pb={3} px={1} overflow="auto">
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForCreateRole.handleSubmit}
                  >
                    <MDBox mb={2}>
                      <MDTypography
                        variant="h6"
                        fontWeight="medium"
                        flexGrow={1}
                        style={{ fontWeight: "500" }}
                      >
                        Role Name
                      </MDTypography>

                      <MDInput
                        type="text"
                        name="roleName"
                        fullWidth
                        autoComplete="off"
                        onChange={formikForCreateRole.handleChange}
                        onBlur={formikForCreateRole.handleBlur}
                        value={formikForCreateRole.values.roleName}
                        error={
                          formikForCreateRole.touched.roleName &&
                          formikForCreateRole.errors.roleName &&
                          true
                        }
                        inputProps={{
                          maxLength: 45,
                        }}
                      />
                      {formikForCreateRole.touched.roleName &&
                        formikForCreateRole.errors.roleName && (
                          <TextError
                            msg={formikForCreateRole.errors.roleName}
                          />
                        )}
                    </MDBox>
                    <MDBox mb={2}>
                      <MDTypography
                        variant="h6"
                        fontWeight="medium"
                        flexGrow={1}
                        style={{ fontWeight: "500" }}
                      >
                        Description
                      </MDTypography>

                      <MDInput
                        // type="text"
                        name="description"
                        fullWidth
                        autoComplete="off"
                        onChange={formikForCreateRole.handleChange}
                        onBlur={formikForCreateRole.handleBlur}
                        value={formikForCreateRole.values.description}
                        error={
                          formikForCreateRole.touched.description &&
                          formikForCreateRole.errors.description &&
                          true
                        }
                        inputProps={{
                          maxLength: 45,
                        }}
                      />
                      {formikForCreateRole.touched.description &&
                        formikForCreateRole.errors.description && (
                          <TextError
                            msg={formikForCreateRole.errors.description}
                          />
                        )}
                    </MDBox>

                    <>
                      {/* <MDBox mb={2}>
                        <MDTypography
                          variant="h6"
                          fontWeight="medium"
                          style={{ fontWeight: "500" }}
                        >
                          Select Client
                        </MDTypography>

                        <Select
                          isClearable
                          className="select-css"
                          maxMenuHeight={90}
                          name="clientId"
                          onBlur={() => {
                            formik.handleBlur({
                              target: {
                                name: "clientId",
                              },
                            });
                          }}
                          value={
                            clientSelected
                              ? clientOptions.find(
                                  (option) =>
                                    option.value === clientSelected.value
                                )
                              : null
                          }
                          options={clientOptions}
                          onChange={(selectedOption) => {
                            handleClientSelected(selectedOption);
                            formik.setFieldValue("clientId", selectedOption);
                          }}
                        />
                        {formik.touched.clientId && formik.errors.clientId && (
                          <TextError msg={formik.errors.clientId} />
                        )}
                      </MDBox> */}
                      <MDBox mb={2}>
                        <MDTypography
                          variant="h6"
                          fontWeight="medium"
                          style={{ fontWeight: "500" }}
                        >
                          Select Component
                        </MDTypography>
                        <Select
                          isMulti
                          isClearable
                          className="select-css"
                          maxMenuHeight={130}
                          placeholder="Choose one..."
                          name="componentId"
                          value={componentOptions.filter(
                            (option) =>
                              selectedValues.componentIds &&
                              selectedValues.componentIds.some(
                                (selected) =>
                                  selected.component === option.value,
                              ),
                          )}
                          options={componentOptions}
                          onChange={(selectedOption) => {
                            handleComponentSelected(selectedOption);
                            formikForCreateRole.setFieldValue(
                              "componentId",
                              selectedOption,
                            ); // passing the full option to Formik
                          }}
                        />
                        {formikForCreateRole.errors.componentId && (
                          <TextError
                            msg={formikForCreateRole.errors.componentId}
                          />
                        )}
                      </MDBox>
                    </>

                    {/* {roleName == "superadmin" && ( */}
                    <MDBox mb={0}>
                      <MDTypography
                        variant="h6"
                        fontWeight="medium"
                        style={{ fontWeight: "500" }}
                      >
                        Modules
                      </MDTypography>
                    </MDBox>
                    {/* )} */}
                    {subModuleDataForCreate.length > 0 && (
                      <div className="card flex justify-content-center">
                        <Tree
                          value={subModuleDataForCreate}
                          selectionMode="checkbox"
                          selectionKeys={selectedKeys}
                          onSelectionChange={(e) => setSelectedKeys(e.value)}
                          style={{ width: "100%" }}
                          filter
                          filterMode="lenient"
                          nodeTemplate={(node, options) => (
                            <span>
                              <span
                                style={{
                                  display: "inline-block",
                                  width: 12,
                                  height: 12,
                                  borderRadius: "50%",
                                  background: node.color,
                                  marginRight: 8,
                                  verticalAlign: "middle",
                                }}
                              />
                              {node.label}
                            </span>
                          )}
                        />
                      </div>
                    )}

                    {/* {productsList ? getMainAccordionForCreateRole() : null} */}

                    <MDBox ml={2} mr={2}>
                      <MDBox></MDBox>
                    </MDBox>

                    <MDBox>
                      <Collapse in={isErrorCreateRole}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorCreateRole(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {/* Please check the details. Server error! */}
                          {createErrorMsg}
                        </Alert>
                      </Collapse>
                      <Collapse in={isSuccessCreateRole}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsSuccessCreateRole(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Role created successfully
                        </Alert>
                      </Collapse>
                    </MDBox>
                    <MDBox mt={2}>
                      {!submitLoader ? (
                        <MDButton
                          variant="contained"
                          color="info"
                          fullWidth
                          type="submit"
                          disabled={!formikForCreateRole.isValid}
                        >
                          Submit
                        </MDButton>
                      ) : (
                        <MDButton
                          variant="contained"
                          color="info"
                          fullWidth
                          type="submit"
                          disabled={!formikForCreateRole.isValid}
                        >
                          <CircularProgress
                            style={{ color: "white", marginRight: "10px" }}
                            size={20}
                          />
                          Submiting...{" "}
                        </MDButton>
                      )}
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>

            {/* ///////////////// edited model ------------- */}
            <Modal
              open={openEditRoleModal}
              onClose={handleCloseEditRoleModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForCreateRole}>
                <MDBox ml={1} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Edit Role
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseEditRoleModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>

                <hr />

                <MDBox pt={1} pb={3} px={1} overflow="auto">
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formik.handleSubmit}
                  >
                    <MDBox mb={2}>
                      <MDTypography
                        variant="h6"
                        fontWeight="medium"
                        flexGrow={1}
                        style={{ fontWeight: "500" }}
                      >
                        Role Name
                      </MDTypography>

                      <MDInput
                        type="text"
                        name="roleName"
                        fullWidth
                        autoComplete="off"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.roleName}
                        error={
                          formik.touched.roleName &&
                          formik.errors.roleName &&
                          true
                        }
                        inputProps={{
                          maxLength: 45,
                        }}
                      />
                      {formik.touched.roleName && formik.errors.roleName && (
                        <TextError msg={formik.errors.roleName} />
                      )}
                    </MDBox>
                    <MDBox mb={2}>
                      <MDTypography
                        variant="h6"
                        fontWeight="medium"
                        flexGrow={1}
                        style={{ fontWeight: "500" }}
                      >
                        Description
                      </MDTypography>

                      <MDInput
                        // type="text"
                        name="description"
                        fullWidth
                        autoComplete="off"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.description}
                        error={
                          formik.touched.description &&
                          formik.errors.description &&
                          true
                        }
                        inputProps={{
                          maxLength: 45,
                        }}
                      />

                      {formik.touched.description &&
                        formik.errors.description && (
                          <TextError msg={formik.errors.description} />
                        )}
                    </MDBox>
                    <MDBox mb={2}>
                      <MDTypography
                        variant="h6"
                        fontWeight="medium"
                        style={{ fontWeight: "500" }}
                      >
                        Select Client
                      </MDTypography>

                      <Select
                        isClearable
                        className="select-css"
                        maxMenuHeight={90}
                        name="clientId"
                        onBlur={() => {
                          formik.handleBlur({
                            target: {
                              name: "clientId",
                            },
                          });
                        }}
                        value={assemblyTypesSelectedForEdit}
                        options={clientOptions}
                        onChange={(selectedOption) => {
                          handleChangeAssemblyTypesForEdit(selectedOption);
                          formik.setFieldValue("clientId", selectedOption);
                        }}
                      />
                      {formik.touched.clientId && formik.errors.clientId && (
                        <TextError msg={formik.errors.clientId} />
                      )}
                    </MDBox>
                    <MDBox mb={2}>
                      <MDTypography
                        variant="h6"
                        fontWeight="medium"
                        style={{ fontWeight: "500" }}
                      >
                        Select Component
                      </MDTypography>

                      <Select
                        isClearable
                        className="select-css"
                        maxMenuHeight={90}
                        name="componentId"
                        onBlur={() => {
                          formik.handleBlur({
                            target: {
                              name: "componentId",
                            },
                          });
                        }}
                        isMulti
                        defaultValue={componentTypesSelectedForEdit}
                        options={componentUpdateOptions}
                        onChange={(selectedOption) => {
                          handleChangeComponentTypesForEdit(selectedOption);
                          formik.setFieldValue("componentId", selectedOption);
                        }}
                      />
                      {formik.touched.componentId &&
                        formik.errors.componentId && (
                          <TextError msg={formik.errors.componentId} />
                        )}
                    </MDBox>
                    {/* <MDBox mb={2}>
                      <MDTypography
                        variant="h6"
                        fontWeight="medium"
                        style={{ fontWeight: "500" }}
                      >
                        Department Name
                      </MDTypography>
                      <Select
                        isClearable
                        className="select-css"
                        maxMenuHeight={130}
                        placeholder="Choose one..."
                        name="departmentId"
                        options={departmentsOptions}
                        value={departmentSelected}
                        onChange={(selectedOption) => {
                          handleDepartmentSelected(selectedOption);
                          formik.setFieldValue("departmentId", selectedOption);
                        }}
                      />
                      {formik.errors.departmentId && (
                        <TextError msg={formik.errors.departmentId} />
                      )}
                    </MDBox> */}

                    <MDBox mb={0}>
                      <MDTypography variant="h6" fontWeight="medium">
                        Modules
                      </MDTypography>
                    </MDBox>
                    {!editLoading ? (
                      <div className="card flex justify-content-center">
                        <Tree
                          value={editModulesByComponentId}
                          selectionMode="checkbox"
                          selectionKeys={selectedKeys}
                          onSelectionChange={(e) => setSelectedKeys(e.value)}
                          style={{ width: "100%" }}
                          filter
                          filterMode="lenient"
                          nodeTemplate={(node, options) => (
                            <span>
                              <span
                                style={{
                                  display: "inline-block",
                                  width: 12,
                                  height: 12,
                                  borderRadius: "50%",
                                  background: node.color,
                                  marginRight: 8,
                                  verticalAlign: "middle",
                                }}
                              />
                              {node.label}
                            </span>
                          )}
                        />
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginTop: "100px",
                          marginBottom: "100px",
                        }}
                      >
                        <CircularProgress color="info" />
                      </div>
                    )}
                    {/* <MDBox>{productsList ? getMainAccordion() : null}</MDBox> */}
                    <MDBox>
                      <Collapse in={isErrorEditRole}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorEditRole(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {/* Please check the details. Server error! */}
                          {editErrorMsg}
                        </Alert>
                      </Collapse>
                      <Collapse in={isSuccessEditRole}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsSuccessEditRole(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Role updated successfully
                        </Alert>
                      </Collapse>
                    </MDBox>
                    <MDBox mt={2}>
                      {!submitLoader ? (
                        <MDButton
                          variant="contained"
                          color="success"
                          fullWidth
                          type="submit"
                          disabled={!formik.isValid}
                        >
                          Update
                        </MDButton>
                      ) : (
                        <MDButton
                          variant="contained"
                          color="success"
                          fullWidth
                          type="submit"
                          disabled={!formik.isValid}
                        >
                          <CircularProgress
                            style={{ color: "white", marginRight: "10px" }}
                            size={20}
                          />
                          Updating...{" "}
                        </MDButton>
                      )}
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Grid>
              <Modal
                open={openViewModal}
                onClose={handleCloseViewModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForCreateRole}>
                  <MDBox ml={1} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                      View Access Module
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseViewModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            padding: "5px",
                            marginBottom: "5px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>

                  <hr />

                  <MDBox t={1} pb={3} px={1} overflow="auto">
                    <MDCard>
                      <MDBox mt={2}>
                        <div>
                          <MDCard>
                            <MDCard>
                              <MDCard>
                                <MDBox>
                                  <MDBox mb={0}>
                                    <MDTypography
                                      variant="h6"
                                      fontWeight="medium"
                                    >
                                      Modules
                                    </MDTypography>
                                  </MDBox>

                                  {!viewLoading ? (
                                    <div className="card flex justify-content-center">
                                      <Tree
                                        value={moduleDataForView}
                                        selectionMode="none"
                                        className="w-full md:w-30rem"
                                      />
                                    </div>
                                  ) : (
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        marginTop: "100px",
                                        marginBottom: "100px",
                                      }}
                                    >
                                      <CircularProgress color="info" />
                                    </div>
                                  )}
                                  {/* {productsList
                                    ? getMainAccordionForView()
                                    : null} */}
                                </MDBox>
                              </MDCard>
                            </MDCard>
                          </MDCard>
                        </div>
                      </MDBox>
                    </MDCard>
                  </MDBox>
                </MDCard>
              </Modal>
            </Grid>
          </Grid>
        </MDBox>
      </>
      {/* {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )} */}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getAllRolesReducer: state.getAllRolesReducer,
    getModulesReducer: state.getModulesReducer,
    getSubModulesReducer: state.getSubModulesReducer,
    getSubModulesForViewReducer: state.getSubModulesForViewReducer,
    getModulesForViewReducer: state.getModulesForViewReducer,
    getAdminModuleRolesReducer: state.getAdminModuleRolesReducer,
    componentsReducer: state.getComponentsReducer,
    getSubModulesForCreateRoleReducer: state.getSubModulesForCreateRoleReducer,
    getAllClientsReducer: state.getAllClientsReducer,
    departments: state.getDepartmentsReducer,
    getModulesForEditReducer: state.getModulesForEditReducer,
    getModulesForEditRolesReducer: state.getModulesForEditRolesReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    deleteRoles: (jwtToken, productId) =>
      dispatch(deleteRoles(jwtToken, productId)),
    getAllRoles: (jwtToken) => dispatch(getAllRoles(jwtToken)),
    createRoles: (payload, jwtToken) =>
      dispatch(createRoles(payload, jwtToken)),
    editRoles: (payload, jwtToken) => dispatch(editRoles(payload, jwtToken)),
    getModules: (jwtToken) => dispatch(getModules(jwtToken)),
    getSubModuleForCreateRole: (payload, jwtToken) =>
      dispatch(getSubModuleForCreateRole(payload, jwtToken)),
    getSubModule: (jwtToken, roleId, moduleId) =>
      dispatch(getSubModule(jwtToken, roleId, moduleId)),
    getModuleForView: (roleIdForView, jwtToken) =>
      dispatch(getModuleForView(roleIdForView, jwtToken)),
    getModuleForEdit: (roleId, jwtToken) =>
      dispatch(getModuleForEdit(roleId, jwtToken)),
    getSubModuleForView: (jwtToken, payload) =>
      dispatch(getSubModuleForView(jwtToken, payload)),
    getDepartments: (jwtToken) => dispatch(getDepartments(jwtToken)),
    getComponents: (jwtToken) => dispatch(getComponents(jwtToken)),
    getAllClients: (jwtToken) => dispatch(getAllClients(jwtToken)),
    getModulesForEditRole: (payload, jwtToken) =>
      dispatch(getModulesForEditRole(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(UserRoles);
